import Axios from 'axios';

const API_URL = process.env.API_URL + '/api/v1/';

class Banner {
  index() {
    return Axios.get(API_URL + 'banner-list');
  }

  show(banner) {
    return Axios.get(API_URL + `banner/${banner}`);
  }
}

export default new Banner();



// WEBPACK FOOTER //
// ./src/api/banner.js